module.exports = __webpack_public_path__ + "static/media/piper-1-background-secondary.e816a6f7.svg";